/**
 * 칩 (DESIGN_SPEC 6장).
 *
 * - PostTag: 하루(--color-surface-sunken) / 고민(--color-accent 테두리, --color-accent-text 글자)
 * - EvidenceChip: "근거 · {인물/책}". **근거 DB 의 항목을 썼을 때만** 붙입니다 (CLAUDE.md, DEV_SPEC 4.7)
 */
const POST_TAG_LABELS = { day: '하루', worry: '고민' };

export function PostTag({ kind }) {
    const isWorry = kind === 'worry';
    return (
        <span
            className={`inline-flex h-6 items-center rounded-chip px-2 text-micro ${
                isWorry ? 'border border-accent text-accent-text' : 'bg-surface-sunken'
            }`}
        >
            {POST_TAG_LABELS[kind]}
        </span>
    );
}

export function EvidenceChip({ label, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="inline-flex h-8 items-center self-start rounded-chip border border-hairline px-3 text-micro text-text-secondary"
        >
            근거 · {label}
        </button>
    );
}
